// Lien entre une carte et le panneau de détail de sa liste (usePanneauLeads) :
// la carte sait si c'est elle qui est ouverte, sur quel onglet, et peut
// s'ouvrir ou se refermer.
export default function usePanneauCarte(panneau, leadId) {
  const estOuvert = Boolean(panneau && leadId && panneau.leadId === leadId);

  return {
    estOuvert,
    onglet: estOuvert ? panneau.onglet : null,
    // Un clic sur l'entrée déjà ouverte referme le panneau.
    ouvrir: (onglet) => {
      if (!panneau) return;
      if (estOuvert && panneau.onglet === onglet) panneau.fermer();
      else panneau.ouvrir(leadId, onglet);
    },
    fermer: () => panneau && panneau.fermer(),
  };
}
